export default __webpack_public_path__ + "static/media/plan your visit icons.2db52e1c.png";